export default [
  {
    key: 'tran_id',
    label: 'field.abaTransaction',
    type: 'text',
    cols: 12,
  },
]
